export default {
  init() {
    this.events();
  },

  events() {
    $('.copy').on('click', (e) => {
      e.preventDefault();
      const btnEl = $(e.currentTarget);
      const url = btnEl.data('copy');

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url);
      }

      btnEl.addClass('copied');
      setTimeout(() => {
        btnEl.removeClass('copied');
      }, 250);
    });
  },
};
